export function getPackageDetailPath(pkg) {
  if (!pkg) return "/packages";
  return `/packages/${pkg.seo_slug || pkg.uid}`;
}
